export enum AuthSuccessPageType {
  SignUp = 'SignUp',
  ForgotPassword = 'ForgotPassword',
  ResetPassword = 'ResetPassword',
  CreatePassword = 'CreatePassword',
}
